import styled, { keyframes } from 'styled-components';
import BlueBlockIcon from '../../../../../components/assets/svg/BlueBlock.svg';
import GreyBlockIcon from '../../../../../components/assets/svg/GreyBlock.svg';

import { theme } from '../../../../../global';

const rotateBlueBlock = keyframes`
    0% {
        transform: translate(0) rotate(0) skewX(0) scale(1);
    }

    10% {
        transform: translate(0) rotate(0) skewX(0) scale(1);
    }
    
    20% {
        transform: translate(-70%, 30%) rotate(-30deg) scaleX(1.2);
    }

    50% {
        transform: translate(-70%, 40%) rotate(-30deg) scaleX(1.2);
    }

    70% {
        transform: translate(-80%, -10%) rotate(-30deg) scaleX(1.2) skew(-20deg, -10deg);
    }

    100% {
        transform: translate(-70%, -2%) rotate(-30deg) scaleX(1.2) skew(-20deg, -10deg);
    }
`;

const rotateGreyBlock = keyframes`
    0% {
        left: 30px;
        transform: translate(0) rotate(0) skewX(0) scale(1);
    }

    10% {
        left: 30px;
        transform: translate(0) rotate(0) skewX(0) scale(1);
    }
    
    20% {
        left: 0;
        transform: translate(70%, -30%) rotate(-30deg) scaleX(1.2);
    }

    50% {
        left: 0;
        transform: translate(70%, -40%) rotate(-30deg) scaleX(1.2);
    }

    70% {
        left: 0;
        transform: translate(80%, 10%) rotate(-30deg) scaleX(1.2) skew(-20deg, -10deg);
    }

    100% {
        left: 0;
        transform: translate(70%, 2%) rotate(-30deg) scaleX(1.2) skew(-20deg, -10deg);
    }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Description = styled.p`
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: ${theme.colors.font_light};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  padding-top: 50px;
`;

export const BlueBlock = styled.img.attrs({
    src: BlueBlockIcon,
})`
  display: flex;
  animation: ${rotateBlueBlock} 5s infinite;

  @media (max-width: 1358px) {
    width: 140px;
  }
`;

export const GreyBlock = styled.img.attrs({
    src: GreyBlockIcon,
})`
  display: flex;
  position: relative;
  z-index: 1;
  left: 30px;
  animation: ${rotateGreyBlock} 5s infinite;

  @media (max-width: 1358px) {
    width: 140px;
    left: 25px;
  }
`;

export const SecondsLeftText = styled(Description)`
  font-weight: 700;
  color: ${theme.colors.button_primary};
  padding-top: 60px;
`;

export const ButtonsTeamContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 40px 0;

  @media (max-width: 1358px) {
    padding: 20px 0;
  }
`;
